import React from 'react'
import Link from './Link'

const Title = React.memo((props) => {
  const { title, subtitle, titlelink, subtitlelink, children, className="" } = props
  return (
    <div className={"pwa__header " + className}>
      <h1 className="pwa__header__container">
        <span key={title} className="pwa__header__title ellipsis_text fade-in">
          {titlelink && (
            <Link to={titlelink} title={window.gettext('go to') + ' ' + title}>
              {title}
            </Link>
          )}
          {!titlelink && (title)}
        </span>
        { subtitle && (
          <span key={subtitle} className="pwa__header__subtitle ellipsis_text fade-in">
            {subtitlelink && (
              <Link to={subtitlelink } title={gettext('go to') + ' ' + subtitle}>
                {subtitle}
              </Link>
            )}
            {!subtitlelink && (subtitle)}
          </span>
        )}
      </h1>
      { children }
    </div>
  )
})

export default Title
